import groq from "groq";
import { howToFields, howToTypeLiteral } from "../types/howTo";
import { insightFields, insightTypeLiteral } from "../types/insight";
import { getExcludeDraftsFilter } from "./filters";

export type GetSuggestedArticlesQueryArgs = {
  maxResults?: number;
  preview?: boolean;
};

export function getSuggestedArticlesQuery({
  maxResults = 3,
  preview,
}: GetSuggestedArticlesQueryArgs): string {
  return groq`
    *[(_type == ${insightTypeLiteral} || _type == ${howToTypeLiteral})
      && ${getExcludeDraftsFilter(preview)}
    ]
    {
      _type == ${insightTypeLiteral} => {
        ${insightFields}
      },
      _type == ${howToTypeLiteral} => {
        ${howToFields}
      }
    }
    [0...${maxResults}]
  `;
}
